import { render, staticRenderFns } from "./iSpringQuizInfoView.vue?vue&type=template&id=ac5ec5a6&"
import script from "./iSpringQuizInfoView.vue?vue&type=script&lang=js&"
export * from "./iSpringQuizInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports